import { render } from "./BrowserJobItem.vue?vue&type=template&id=4e5e51d5&scoped=true&ts=true"
import script from "./BrowserJobItem.vue?vue&type=script&lang=ts"
export * from "./BrowserJobItem.vue?vue&type=script&lang=ts"

import "./BrowserJobItem.vue?vue&type=style&index=0&id=4e5e51d5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5e51d5"]])

export default __exports__